import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  width: 320,
  backgroundColor: theme.palette.white,
  boxShadow: `0 1px 5px ${theme.palette.shadow.medium}`,
  borderRadius: theme.radii.lg,
  flexShrink: 0,

  // FE-14: колонка фильтров прилипает — иначе после прокрутки к ней
  // приходится возвращаться в начало страницы
  [theme.up("lg")]: {
    position: "sticky",
    top: theme.spacing(4),
    maxHeight: `calc(100dvh - ${theme.spacing(6)}px)`,
    overflowY: "auto",
  },

  [theme.down("xl")]: {
    width: 270,
  },

  [theme.down("lg")]: {
    width: "100%",
  },
}));

export const FiltersButton = styled("button")(({ theme }) => ({
  position: "relative",
  borderRadius: 0,
  width: "100%",
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.text.muted}`,
  color: theme.palette.text.primary,
  margin: 0,
  height: 32,
  fontSize: 14,
  cursor: "pointer",

  [theme.up("lg")]: {
    display: "none",
  },
}));

export const IconBlock = styled("span")(({ theme }) => ({
  position: "absolute",
  right: 8,
  top: 5,
  display: "flex",
  fontSize: 20,
  color: theme.palette.text.primary,
  transform: "rotate(0deg)",
  transition: "all .3s ease",

  "&.active": {
    transform: "rotate(180deg)",
  },
}));

export const FiltersBlock = styled("div")(({ theme }) => ({
  height: "auto",
  overflow: "hidden",

  [theme.down("lg")]: {
    height: 0,

    "&.active": {
      height: "auto",
    },
  },
}));

// FE-14: шапка колонки — заголовок и сброс, как в макете
export const FiltersHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: theme.spacing(3),
  padding: `${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(2)}px`,
}));

export const FiltersTitle = styled("div")(({ theme }) => ({
  ...theme.typography.h3,
  color: theme.palette.text.primary,
}));

export const ResetButton = styled("button")(({ theme }) => ({
  ...theme.typography.caption,
  border: "none",
  background: "transparent",
  color: theme.palette.text.link,
  cursor: "pointer",
  padding: theme.spacing(1),

  "&:hover": {
    color: theme.palette.text.linkHover,
    textDecoration: "underline",
  },
}));
